import { render, staticRenderFns } from "./DatabaseEmailWrapper.vue?vue&type=template&id=61cfcea6"
import script from "./DatabaseEmailWrapper.vue?vue&type=script&lang=js"
export * from "./DatabaseEmailWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports